import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";

import { showErrorToast } from "#app/notifications";
import { AccessTokenSingleton } from "#modules/auth/domain/AccessTokenSingleton";
import { signUp } from "#modules/auth/infra/signUp.api";

type Option = {
  onSuccess?: () => void;
};

export const useSignUp = (options?: Option) => {
  const { t } = useTranslation();

  const { mutate, ...rest } = useMutation({
    mutationFn: signUp,
    onSuccess: (data) => {
      AccessTokenSingleton.getInstance().setAccessToken(data.accessToken);
      localStorage.setItem("accessTokenApi", data.accessToken);

      options?.onSuccess?.();
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        showErrorToast({
          title: t("common.error"),
          message: error.response?.data.message,
        });
      } else {
        showErrorToast({
          title: error instanceof Error ? error.message : t("common.error"),
        });
      }
    },
  });

  return { signUp: mutate, ...rest };
};
